import { mapState } from "vuex"

const ui_utilities = {
    methods: {
        scroll_to (target) {
            if(!target) return
            const scroll_margin = parseInt(getComputedStyle(target)["scroll-margin-top"]) || 0
            window.scrollTo({ top: target.getBoundingClientRect().y + window.scrollY - scroll_margin, left: 0, behavior: "smooth" })
        },
        email_can_not_login (email) {
            return !!email && (email.indexOf(`@${this.constants("LOGIN_DOMAIN")}`) < 0)
        }
    },
    computed: {
        ...mapState(["app_context"]),
        print_screen () {
            const mq = window.matchMedia("print")
            return !!mq && !!mq.matches
        },
        small_screen () {
            return !!this.$mq.match(/^(xs|sm|md|lg)$/i)
        },
        is_public_page () {
            return !this.$route.meta || (!this.$route.meta.login_required && !this.$route.meta.admin_route)
        },
        roles () {
            return Object.values(this.constants("roles"))
        },
        filtered_roles () {
            if(!this.is_developer) return this.roles.filter(role => role.id !== this.constants("roles", "ROLE_DEVELOPER").id)
            return this.roles
        },
        parts () {
            return Object.values(this.constants("parts"))
        }
    }
}

export default ui_utilities
